<template>
  <div class="full-width-table">
    <sdCards :title="cardTitle" bodypadding="0px">
      <template #button>
        <CardDateNavVue @date-changed="dateChanged" />
      </template>
      <div class="table-bordered top-seller-table table-responsive">
        <a-table :columns="columns" :dataSource="data" :pagination="false" size="small">
          <template v-if="decoder($store.state.auth.is_root) == 1" #price="{ record }">
            <a-space>
              <span>
                {{ record.price + ' TL' }}
              </span>
            </a-space>
          </template>
          <template #revenue="{ record }">
            <a-space>
              <span>
                {{ record.revenue + ' TL' }}
              </span>
            </a-space>
          </template>
        </a-table>
      </div>
    </sdCards>
  </div>
</template>

<script>
import { priceFormat } from '@/utility/helper.js';
import CardDateNavVue from '../CardDateNav.vue';

export default {
  components: {
    CardDateNavVue,
  },
  data() {
    return {
      data: null,
      date: 'year',
      columns: [
        {
          title: this.$t('pages.home.table-sale-app-name'),
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: this.$t('pages.home.table-sale-total-price'),
          dataIndex: 'price',
          key: 'price',
          slots: { customRender: 'price' },
        },
        {
          title: this.$t('pages.home.table-sale-number'),
          dataIndex: 'sold',
          key: 'sold',
        },
        {
          title: this.$t('pages.home.table-sale-total-revenue'),
          dataIndex: 'revenue',
          key: 'revenue',
          slots: { customRender: 'revenue' },
        },
      ],
    };
  },
  props: {
    cardTitle: {
      type: String,
    },
    endpoint: {
      type: String,
    },
  },
  created() {
    if (this.decoder(this.$store.state.auth.is_root) == 0) {
      // Geliştirici için toplam gelir sütunu tablodan çıkarıldı.
      this.columns.splice(1, 1);
    }
    this.getData();
  },
  methods: {
    getData() {
      this.$appAxios.post(this.endpoint, { date: this.date })
        .then(response => {
          if (response.data.status === true) {
            var tableRecords = response.data.data;
            this.data = [];
            var _this = this;
            tableRecords.forEach(item => {
              _this.data.push({
                key: item.app_id,
                name: item.application,
                price: this.decoder(this.$store.state.auth.is_root) == 1 ? priceFormat(item.order_total) : '-',
                sold: item.number,
                revenue: priceFormat(item.revenue),
              });
            });
          } 
          this.isCard_Loading = false;
        })
        .catch(e => {
        });
    },
    dateChanged(value) {
      this.date = value;
      this.getData();
    },
    decoder(value) {
      return atob(value);
    },
  },
};
</script>
